export default __webpack_public_path__ + "static/media/physical-black.bd5c9541.svg";